export const CHORD_ON_EVENT = 'CHORD_ON_EVENT';
export const CHORD_OFF_EVENT = 'CHORD_OFF_EVENT';
export const NEW_CHORD = 'NEW_CHORD';
export const SAME_CHORD = 'SAME_CHORD';
export const OCTAVE_UP = 'OCTAVE_UP';
export const OCTAVE_DOWN = 'OCTAVE_DOWN';
export const TWO_OCTAVES_DOWN = 'TWO_OCTAVES_DOWN';
export const TWO_OCTAVES_UP = 'TWO_OCTAVES_UP';
